<template>
<v-layout :align-start="properties.length == 0" :justify-start="properties.length == 0" :fill-height="properties.length == 0" row wrap>
   <v-navigation-drawer
      v-model="drawer"
      fixed
      clipped
      class="grey lighten-5 pa-4"
      app
    >
    <v-select
        v-model="towns"
        item-text="name"
        item-value="id"
        :items="usedTowns"
        label="Población"
        multiple
        solo
    ></v-select>
    <v-text-field
        label="Referencia"
        v-model="reference"
    ></v-text-field>
    <v-radio-group v-model="rentOrBuy" v-on:change="changePriceRanges" color="primary">
        <v-radio
            key="1"
            label="Alquiler"
            value="1"
            color="primary"
        ></v-radio>
        <v-radio
            key="2"
            label="Compra"
            value="2"
            color="primary"
        ></v-radio>
    </v-radio-group>
    <v-select
        v-model="minPrice"
        :items="prices"
        label="Precio minimo"
        solo
    ></v-select>
    <v-select
        v-model="maxPrice"

        :items="prices"
        label="Precio maximo"
        solo
    ></v-select>
    <span> Habitaciones </span>
    <v-btn-toggle class="full-width mb-4" mandatory>
        <v-btn block flat
        @click="bedrooms = 0">
            0
        </v-btn>
        <v-btn block flat
        @click="bedrooms = 1">
            1
        </v-btn>
        <v-btn block flat
        @click="bedrooms = 2">
            2
        </v-btn>
        <v-btn block flat
        @click="bedrooms = 3">
            3
        </v-btn>
        <v-btn block flat
        @click="bedrooms = 4">
            4
        </v-btn>
        <v-btn block flat
        @click="bedrooms = 5">
            + 5
        </v-btn>
    </v-btn-toggle>
    <span> Baños </span>
    <v-btn-toggle class="full-width" mandatory>
        <v-btn block flat
        @click="bathrooms = 0">
            0
        </v-btn>
        <v-btn block flat
        @click="bathrooms = 1">
            1
        </v-btn>
        <v-btn block flat
        @click="bathrooms = 2">
            2
        </v-btn>
        <v-btn block flat
        @click="bathrooms = 3">
            3
        </v-btn>
        <v-btn block flat
        @click="bathrooms = 4">
            4
        </v-btn>
        <v-btn block flat
        @click="bathrooms = 5">
            + 5
        </v-btn>
    </v-btn-toggle> 
    <v-btn block color="primary" class="mt-4" @click="search">Aplicar</v-btn>
   </v-navigation-drawer>

   <v-toolbar v-if="$mq !== 'desktop'" flat>
        <v-toolbar-side-icon large @click.stop="drawer = !drawer;"></v-toolbar-side-icon>
   </v-toolbar>

   <v-flex v-if="properties.length == 0" class="parent" xs12 sm12 md12 lg12>
        <v-chip>No existeixe ninguna coincidencia con su busqueda</v-chip>
    </v-flex>
    <v-flex v-for="property in properties" md3 xs12 sm12>
        <v-card :to="'/Property/' + property.id" class="redBorderHover property">
            <v-img
            v-if="property.photoPath !== null" 
            :src="property.photoPath"
            height="29vh"
            class="white--text"
            >
            </v-img>
            <v-card-title>
            <div>
                <span class="price-text">{{ formatMoney(property.price) }} €</span><br>
                <span class="property-title">{{ property.title }}</span><br>
                <span>{{ property.state }}, {{ property.town }}, {{ property.zone }}</span><br>
                <span>{{ property.surface }} m2, {{property.bedroomQuantity }} habitaciones, {{ property.bathroomQuantity }} baños</span>
            </div>
            </v-card-title>
        </v-card>
    </v-flex>
</v-layout>
</template>
<script>
import { GET_PUBLIC_PROPERTIES, GET_PRICE_RANGES, GET_USED_TOWNS } from '@/constants'

export default {
    computed: {
        properties () {
            return this.$store.state.properties;
        },
        usedTowns: function() {
            return this.$store.state.usedTowns;
        }
    },
    data() {
        return {
            towns : [],
            isForRent : false,
            bathrooms: 0,
            bedrooms: 0,
            size: 100,
            reference: "",
            page: 0,
            selectedTowns: [],
            rentOrBuy: "1",
            maxPrice: 0,
            minPrice: 0,
            drawer: false,
            ranges: {},
            prices: [0, 0]
        }
    },
    async mounted() {
        if (this.$mq === "desktop") {
            this.drawer = true;
        }

        await this.$store.dispatch(GET_USED_TOWNS);

        if (typeof this.$route.query.towns === "string") 
        {
            this.towns.push(Number(this.$route.query.towns));
        } 
        else
        {         
            this.towns = this.$route.query.towns;
        }

        this.isForRent = this.$route.query.isForRent;
        this.rentOrBuy = this.isForRent ? "1" : "2";

        this.ranges = await this.$store.dispatch(GET_PRICE_RANGES);

        this.$store.dispatch(GET_PUBLIC_PROPERTIES, 
        { 
            towns : this.towns, 
            isForRent : this.isForRent, 
            page: this.page, 
            size: this.size, 
            reference: this.reference,
            bathrooms: this.bathrooms,
            bedrooms: this.bedrooms,
            minPrice: this.minPrice,
            maxPrice: this.maxPrice
        })

        if (this.isForRent) {
            this.prices = [];
            this.prices.push(this.ranges.minRent);

            var currentValue = this.ranges.minRent + 100;
            while (currentValue <= this.ranges.maxRent) {
                this.prices.push(currentValue);
                currentValue += 100;
            }
        } else {
            this.prices = [];
            this.prices.push(this.ranges.minBuy);

            var currentValue = this.ranges.minBuy + 10000;
            while (currentValue <= this.ranges.maxBuy) {
                this.prices.push(currentValue);
                currentValue += 10000;
            }
        }
    },
    methods : {
         search: async function () {          
            this.ranges = await this.$store.dispatch(GET_PRICE_RANGES);

            await this.$store.dispatch(GET_PUBLIC_PROPERTIES, 
            { 
                towns : this.towns, 
                isForRent : this.rentOrBuy == "1", 
                page: this.page, 
                size: this.size, 
                reference: this.reference,
                bathrooms: this.bathrooms,
                bedrooms: this.bedrooms,
                minPrice: this.minPrice,
                maxPrice: this.maxPrice
            });

            if (this.$mq !== "desktop") {
                this.drawer = false;
            }
        },
        formatMoney : function (amount, decimalCount = 0, decimal = ",", thousands = ".") {
            try {
                decimalCount = Math.abs(decimalCount);
                decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                const negativeSign = amount < 0 ? "-" : "";

                let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                let j = (i.length > 3) ? i.length % 3 : 0;

                return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
            } catch (e) {
                console.log(e)
            }
        },
        changePriceRanges : function (value) {
            this.maxPrice = 0;
            this.minPrice = 0;

            if (value == 1) {
                this.prices = [];
                this.prices.push(this.ranges.minRent);

                var currentValue = this.ranges.minRent + 100;
                while (currentValue <= this.ranges.maxRent) {
                    this.prices.push(currentValue);
                    currentValue += 100;
                }
            } else {
                this.prices = [];
                this.prices.push(this.ranges.minBuy);

                var currentValue = this.ranges.minBuy + 10000;
                while (currentValue <= this.ranges.maxBuy) {
                    this.prices.push(currentValue);
                    currentValue += 10000;
                }
            }
        }
    }
}
</script>

<style>

.full-width {
    width : 100%;
}

.price-text {
    font-size: 1.5em;
    font-weight: lighter;
}

.redBorderHover{
    border:1px solid black;
}

.property {
    margin: 10px;

    border: none;
}

@media (max-width: 961px)
{
    .property {
        margin: 0;
    }
}

.v-navigation-drawer__border
{
    display: none
}

.property-title
{
    color:#840011;
    font-weight: lighter;
    font-size: 2em;
}

.center {
    display: flex;
  justify-content: center;
  align-items: center;
}

</style>

